/* eslint-disable react/require-default-props */
import React from 'react';
import { CheckboxProps } from 'antd';
import { StyledCheckBox, Title } from './styles';

interface IProps extends CheckboxProps {
    title: string;
    error?: string;
}

const CheckBox: React.FC<IProps> = ({ title, value, ...rest }) => {
    return (
        <StyledCheckBox checked={value} {...rest}>
            <Title>{title}</Title>
        </StyledCheckBox>
    );
};

export default CheckBox;
